import React from 'react'
import { MarketplaceProduct } from '../../../types/marketplace-product'
import { useRecommendations } from '.'
import RelatedProducts from './related-products-base'

interface IRelatedProductsGroup {
  product: MarketplaceProduct
  variantGroupCode: string
}

export const RelatedProductsGroup: React.FunctionComponent<
  React.PropsWithChildren<IRelatedProductsGroup>
> = ({ product, variantGroupCode }) => {
  const { recommendations, indexName } = useRecommendations({
    variantGroupCode,
    product,
    shopId: `${product.shop.id}`,
    facetFilters: [],
  })
  const relatedProductsFromShop = recommendations.filter(
    recommendations => recommendations.shop.id == product.shop.id
  )
  const relatedProductsFromAll = recommendations.filter(
    recommendations => recommendations.shop.id != product.shop.id
  )
  const title = {
    relatedProductsAll: 'You may also like',
    relatedProductsShop: `More from ${product.shop.name}`,
  }

  return (
    <>
      <RelatedProducts
        title={title.relatedProductsAll}
        recommendations={relatedProductsFromAll}
        analytics={{ indexName }}
      />
      <RelatedProducts
        title={title.relatedProductsShop}
        recommendations={relatedProductsFromShop}
        analytics={{ indexName }}
      />
    </>
  )
}
